import React from 'react';
import { Button, Input, Modal } from 'antd';

import Select from '../../common/Select';

const GroupsModal = ({
  onOk,
  onClose,
  onGroupIdChange,
  onGroupPermissionsChange,
  group,
  updating,
  disabled,
}) =>
  group && (
    <Modal
      className="groups-editing-modal"
      title="Group"
      wrapClassName="global-filter-modal"
      open={!updating}
      onOk={onOk}
      onCancel={onClose}
      footer={[
        <Button
          className="create-group_button"
          key="submit"
          disabled={disabled}
          type="primary"
          onClick={onOk}
        >
          OK
        </Button>,
        <Button className="cancel-modal_group_button" key="back" onClick={onClose}>
          Cancel
        </Button>,
      ]}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <div style={{ flex: 1 }}>Group ID</div>
          <div style={{ flex: 4 }}>
            <Input
              className="ant-input-border-bottom"
              id="group-id"
              value={group.groupId.trim()}
              onChange={(e) => onGroupIdChange(e.target.value)}
            />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ flex: 1 }}>Permissions</div>
          <div id="group_permission_select" style={{ flex: 4 }}>
            <Select
              className="ant-select-border-bottom"
              style={{ width: '100%' }}
              multi
              customizable
              onChange={onGroupPermissionsChange}
              value={group.permissions}
            />
          </div>
        </div>
      </div>
    </Modal>
  );

export default GroupsModal;
